/* eslint-disable import/prefer-default-export */
import { gql } from 'graphql-request';

export const listPomRequestsStatusGql = gql`
  query listPomRequestsStatus(
    $limit: Int = 25
    $offset: Int = 0
    $filter: ListPomRequestsFilter
    $sortBy: ListPomRequestsSortBy = { sortKey: createdAt, sortOrder: DESC }
  ) {
    listPomRequestsStatus(limit: $limit, offset: $offset, filter: $filter, sortBy: $sortBy) {
      count
      result {
        orderType
        referenceId
        pomOrderId
        patient {
          mpi
          firstName
          lastName
        }
        partner {
          partnerName
          partnerUuid
        }
        externalPatientId
        createdAt
        status
        requestId
        partnerAccountId
        reshipmentOf
      }
    }
  }
`;

export const getRequestByReferenceIdGql = gql`
  query getPomRequestByReferenceId(
    $referenceId: String!
    $requestId: String!
    $orderId: String
    $partnerId: String!
  ) {
    getPomRequestByReferenceId(
      referenceId: $referenceId
      requestId: $requestId
      orderId: $orderId
      partnerId: $partnerId
    ) {
      orderType
      referenceId
      pomOrderId
      externalPatientId
      patientContactFromPartner {
        partnerId
        partnerName
        patientEmail
        patientPhoneNumber
      }
      status
      createdAt
      prescriptions {
        prescriptionId
        description
        strength
        expirationDate
        dispenseAsWritten
        directions
        quantity
        totalRefills
        needsByDate
        shipByDate
        notes
        prescriptionType
        reviewReason
        originatingPharmacy {
          ...PharmacyFields
        }
        transferPharmacies {
          ...PharmacyFields
        }
        prescribedBy {
          npi
          firstName
          lastName
          middleName
          phoneNumber
          address {
            addressLine1
            addressLine2
            addressCity
            addressState
            addressZip
          }
          dea
          deaState
          emailAddress
          title
          verificationStatus
          name
        }
      }
      patient {
        mpi
        firstName
        lastName
        email
        mobilePhone
        gender
        dob
      }
      partner {
        partnerName
      }
      prxSalesRep {
        firstName
        lastName
        unavailable
      }
      practice {
        practiceId
        practiceName
        prescriberName
        phone
        line1
        line2
        city
        state
        zip
      }
      events
      errors
      shippingAddress {
        line1
        line2
        city
        state
        zip
      }
      deliveryInstructions
      originalRequestId
    }
  }

  fragment PharmacyFields on Pharmacy {
    pharmacyAddress {
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
    }
    phoneNumber
    dea
    name
    npi
    pharmacistName
    transferDate
  }
`;

export const getOriginalOrderPayloadGql = gql`
  query getOriginalOrderPayload($originalRequestId: String!) {
    getOriginalOrderPayload(originalRequestId: $originalRequestId)
  }
`;

export const resendPartnerWebhookGql = gql`
  mutation resendPartnerWebhook($eventRegistryPkId: String!) {
    resendPartnerWebhook(eventRegistryPkId: $eventRegistryPkId)
  }
`;
